import axios from "axios";

const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const BASE = isLocal ? process.env.REACT_APP_BACKEND_URL : window.location.origin;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (!orig) return Promise.reject(err);
    const isGet = (orig.method || "get").toLowerCase() === "get";
    if (err.code === "ERR_NETWORK" && !orig._netRetry && isGet) {
      orig._netRetry = true;
      await new Promise((res) => setTimeout(res, 1500));
      return api(orig);
    }
    if (err.response?.status === 401 && !orig._retry && !orig.url?.includes("/auth/")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) {
    if (e?.code === "ERR_NETWORK" || e?.message === "Network Error") {
      return "No hay conexión con el servidor. Verifica tu internet (o cambia de WiFi a datos) e inténtalo de nuevo.";
    }
    return e?.message || "Error inesperado. Intenta de nuevo.";
  }
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export function fmtUSD(n) {
  if (n == null || isNaN(n)) return "—";
  return `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export const STATUS_LABELS = {
  submitted: "Enviada",
  deposit_paid: "Depósito pagado",
  bidding: "Pujando",
  won: "Ganada",
  lost: "Perdida",
  payment_due: "Pago pendiente",
  paid: "Pagado",
  in_transit: "En tránsito",
  delivered: "Entregado",
  refund_pending: "Reembolso en proceso",
  refunded: "Reembolsado",
  cancelled: "Cancelada",
};

export const STATUS_LABELS_EN = {
  submitted: "Submitted",
  deposit_paid: "Deposit Paid",
  bidding: "Bidding",
  won: "Won",
  lost: "Lost",
  payment_due: "Payment Due",
  paid: "Paid",
  in_transit: "In Transit",
  delivered: "Delivered",
  refund_pending: "Refund Pending",
  refunded: "Refunded",
  cancelled: "Cancelled",
};

export function statusLabel(status, lang) {
  const map = lang === "en" ? STATUS_LABELS_EN : STATUS_LABELS;
  return map[status] || status;
}

export const STATUS_COLORS = {
  submitted: "bg-slate-500/20 text-slate-300 border-slate-500/40",
  deposit_paid: "bg-blue-500/15 text-blue-300 border-blue-500/40",
  bidding: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  won: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  lost: "bg-red-500/15 text-red-300 border-red-500/40",
  payment_due: "bg-orange-500/15 text-orange-300 border-orange-500/40",
  paid: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  in_transit: "bg-sky-500/15 text-sky-300 border-sky-500/40",
  delivered: "bg-emerald-500/20 text-emerald-200 border-emerald-400/50",
  refund_pending: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  refunded: "bg-slate-500/20 text-slate-200 border-slate-400/40",
  cancelled: "bg-slate-600/20 text-slate-400 border-slate-500/40",
};

export default api;
